<div class="p-l">
  <span class="subheader">Legen Sie ein neues Passwort fest</span>
  <p>Bitte legen Sie ein Passwort fest. Drei der folgenden Kriterien müssen erfüllt sein:</p>
  <ul class="mb-l">
    <li>ein Klein- oder Großbuchstabe</li>
    <li>eine Zahl oder ein Sonderzeichen</li>
    <li>die minimale Passwortlänge beträgt 8 Zeichen</li>
  </ul>


  <form [formGroup]="newPasswordForm">
    <mat-form-field appearance="outline">
      <mat-label>Altes Passwort</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="old_password" tabindex="1">
      <button mat-icon-button
        matSuffix
        (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon fontSet="material-symbols-outlined">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      @if (old_password.hasError('minlength')) {
        <mat-error>
          Ihr Passwort muss mindestens 8 Zeichen lang sein.
        </mat-error>
      }
      @if (old_password.hasError('passwordval')) {
        <mat-error>
          Ihr Passwort muss mindestens ein Kleinbuchstabe, ein Großbuchstabe, eine Zahl und eine Sonderzeichen haben.
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Neues Passwort</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" tabindex="1">
      <button mat-icon-button
        matSuffix
        (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon fontSet="material-symbols-outlined">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      @if (password.hasError('minlength')) {
        <mat-error>
          Ihr Passwort muss mindestens 8 Zeichen lang sein.
        </mat-error>
      }
      @if (password.hasError('passwordval')) {
        <mat-error>
          Ihr Passwort muss mindestens ein Kleinbuchstabe, ein Großbuchstabe, eine Zahl und eine Sonderzeichen haben.
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Passwort wiederholen</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="password_repeat" tabindex="2"/>
      <button mat-icon-button
        matSuffix
        (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon fontSet="material-symbols-outlined">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      @if (password_repeat.hasError('required')) {
        <mat-error>
          Bitte wiederholen Sie Ihr Passwort.
        </mat-error>
      }
      @if (password_repeat.hasError('mustMatch')) {
        <mat-error>
          Ihre Passwörter stimmen nicht überein.
        </mat-error>
      }
    </mat-form-field>
    <button mat-flat-button color="primary" class="mr-m" (click)="onPasswordChange()">Speichern</button>
    <button mat-button (click)="closeDialog()">Abbrechen</button>

  </form>
</div>
